'use client';

import { useEffect, useState, useMemo } from 'react';
import Image from 'next/image';
import { siteImage } from '@/constants/site';

const CustomStoryImageWithDefault = ({
    src,
    width,
    height,
    alt = 'Story',
    className = '',
    style = {},
    onClick,
    unoptimized = true, // 🚨 Se mantiene true para evitar edge requests costosos
    priority = false,
    objectFit = 'cover', // Controlar cómo se ajusta la imagen
    ...props
}) => {
    // ✅ useMemo para memorizar las URLs y evitar recalcularlas en cada render
    const storyImage = useMemo(
        () => (src ? `${src}?width=${width * 1.5}&height=${height * 1.5}` : null),
        [src, width, height]
    );
    const fallbackImage = useMemo(() => `${siteImage}/marca/fondo-oscuro_letras-verdes.png`, []);
    const [imageSrc, setImageSrc] = useState(storyImage || fallbackImage);

    // ✅ Solo re-ejecutar cuando cambia la URL de storyImage (que ya está memoizada)
    useEffect(() => {
        setImageSrc(storyImage || fallbackImage);
    }, [storyImage, fallbackImage]);

    const handleError = () => {
        console.warn(`⚠️ Error cargando la imagen: ${storyImage}`);
        setImageSrc(fallbackImage);
    };

    return (
        <Image
            src={imageSrc}
            width={width}
            height={height}
            alt={alt}
            className={className}
            style={{ ...style, objectFit }}
            onClick={onClick}
            unoptimized={unoptimized} // 🔒 Se mantiene true por tu caso específico
            priority={priority}
            onError={handleError}
            {...props}
        />
    );
};

export default CustomStoryImageWithDefault;
